<template>
  <div v-if="surveyData">
    <div class="mdc-card pda-24 mgb-24">
      <div class="t-headline7 font-m">{{ $t("226") }}</div>
      <div class="t-body1 t-color-bodyGrayA mgt-16 font-r">
          {{ surveyData.summary }}
      </div>
    </div>
    <div class="mdc-card pdt-24 pdl-24 pdb-8 pdr-24 mgb-50">
      <div class="d-flex align-items-center justify-content-between mgb-16">
          <div class="t-headline7 font-m flex-grow-1">{{ $t("227") }}</div>
      </div>
      <div class="pdt-16 pdb-16">
        <div class="align-items-center justify-content-between d-flex t-line-h-24">
          <div class="t-body1 font-r t-color-bodyGrayA">{{ $t("697") }}</div>
          <div class="t-body1 font-rn">            
            {{ displayPeriod(surveyData.application) }}
            <!-- {{ $moment(surveyData.application.end).format("L") }} -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utilDateMixin } from "@/mixins/dateUtil";

export default {
  props: ["surveyData"],
  mixins: [utilDateMixin],
};
</script>

<style>
</style>